module.exports = __webpack_public_path__ + "static/media/willmott-dixon-logo.8a07130a.svg";